import React from "react";
import { Link } from "./Link";
import { useLocation } from "react-router-dom";

export const Footer = () => {
  const location = useLocation();

  const year = () => {
    var dt = new Date();
    return dt.getFullYear();
  };

  // Don't show if we're showing the testing view.
  if (location.pathname.includes("testing")) {
    return null;
  }

  return (
    <React.Fragment>
      <footer className='footer text-light mt-auto' style={{ backgroundColor: "#2b2b53" }}>
        <div>
          <Link href='https://www.systemrequirementslab.com/Marketing/PrivacyN.html'>Privacy Policy</Link>
          <span className='px-3'>|</span>
          <Link href='https://www.systemrequirementslab.com/Marketing/TandC.html'>Terms of Service</Link>
        </div>
        <div>
          Want to use{" "}
          <Link href='https://www.systemrequirementslab.com/Marketing/Home.html'>
            System Requirements Lab on your site?
          </Link>
        </div>
        <div>Powered by System Requirements Lab, a technology from Husdawg, LLC</div>
        <div>Copyright © {year()} Husdawg, LLC, All rights reserved.</div>
      </footer>
    </React.Fragment>
  );
};
